import { Component, Input, OnInit } from '@angular/core';
import { CustomerService } from '../../services/customer.service';

@Component({
    selector   : 'my-summary',
    template: require('./summary.component.html'),
    styles: [require('./summary.component.scss')]
})

export class SummaryComponent implements OnInit {

    @Input('privateId') privateId: string;

    summary = this;
    passagePrice = null;
    listModal = {
        'passage' : false
    };

    constructor(public customerService: CustomerService) {

    }

    ngOnInit(): void {
        this.customerService.loadResume(this.privateId);
    }

    returnDate(dateString) {
        if (!dateString)
            return '-';
        let date = new Date(dateString);

        //affiche un signe inifini pour les clients importés
        if (date.getTime() < 1493733600000){
            return '∞';
        }

        let seconds = Math.floor((new Date().getTime() - date.getTime()) / 1000);
        let interval = Math.floor(seconds / 31536000);

        if (interval > 1) {
            return interval + " années";
        }
        interval = Math.floor(seconds / 2592000);
        if (interval > 1) {
            return interval + " m";
        }
        interval = Math.floor(seconds / 86400);
        if (interval > 1) {
            return interval + " j";
        }
        return "0 j";
    }

    toDouble(tmp:number){
        if (tmp)
            return tmp.toFixed(2);
        return '-'
    }

    addPassage(a){
        this.passagePrice = 0;
        let price = a[0].value;
        if (price == "")
            price = "0";
        if (!isNaN(price) && isFinite(price))
            this.customerService.addPassage(this.privateId, price);
        this.passagePrice = null;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/components/summary/summary.component.ts